<script type="text/javascript">
    import ListGroup from '@/components/UI/ListGroup/ListGroup.vue';
    import ListGroupItem from '@/components/UI/ListGroup/Item.vue';

    export default {
        ListGroup,
        ListGroupItem,
    }
</script>